import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";
import { Check, X } from "lucide-react";

const SuccessIcon = () => (
  <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-500">
    <Check className="h-3 w-3 text-white" strokeWidth={3} />
  </div>
);

const ErrorIcon = () => (
  <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-destructive">
    <X className="h-3 w-3 text-white" strokeWidth={3} />
  </div>
);

const WarningIcon = () => (
  <svg className="h-5 w-5 shrink-0" viewBox="0 0 20 20" fill="none">
    <path d="M8.57 3.22c.63-1.09 2.23-1.09 2.86 0l6.86 11.88c.63 1.09-.16 2.45-1.43 2.45H3.14c-1.27 0-2.06-1.36-1.43-2.45L8.57 3.22z" fill="currentColor" className="text-yellow-500" />
    <rect x="9.25" y="7" width="1.5" height="5" rx="0.75" fill="white" />
    <circle cx="10" cy="14" r="0.85" fill="white" />
  </svg>
);

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="bottom-right"
      icons={{
        success: <SuccessIcon />,
        error: <ErrorIcon />,
        warning: <WarningIcon />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
